export const AU_STATES = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT', 'ACT'];

export const STATE_TIMEZONE = {
  NSW: 'Australia/Sydney',
  ACT: 'Australia/Sydney',
  VIC: 'Australia/Melbourne',
  QLD: 'Australia/Brisbane',
  SA: 'Australia/Adelaide',
  WA: 'Australia/Perth',
  TAS: 'Australia/Hobart',
  NT: 'Australia/Darwin',
};

export const COMPANY_SCREEN_FIELDS = ['company_name', 'abn', 'address', 'suburb', 'state', 'postcode', 'phone', 'company_email', 'timezone'];
export const YOU_SCREEN_FIELDS = ['admin_first_name', 'admin_last_name', 'admin_mobile'];

export const FIELD_LABELS = {
  company_name: 'Company name',
  abn: 'ABN',
  address: 'Street address',
  suburb: 'Suburb',
  state: 'State',
  postcode: 'Postcode',
  phone: 'Phone',
  company_email: 'Company email',
  timezone: 'Timezone',
  admin_first_name: 'First name',
  admin_last_name: 'Last name',
  admin_mobile: 'Mobile',
};

function digits(v) {
  return String(v || '').replace(/\D/g, '');
}

export function abnIsValid(abn) {
  const d = digits(abn);
  if (d.length !== 11) return false;
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  const nums = d.split('').map(Number);
  nums[0] -= 1;
  return nums.reduce((sum, n, i) => sum + n * weights[i], 0) % 89 === 0;
}

export function auPhoneIsValid(v) {
  let d = digits(v);
  if (d.startsWith('61')) d = `0${d.slice(2)}`;
  return d.length === 10 && d.startsWith('0');
}

/** Blank is allowed. A typed company phone must be a landline, mobile, or 1300/1800 number. */
export function companyPhoneIsAcceptable(v) {
  const raw = String(v || '').trim();
  if (!raw) return true;
  let d = digits(v);
  if (d.startsWith('61') && d.length >= 11) d = `0${d.slice(2)}`;
  if (d.length !== 10) return false;
  return d.startsWith('0') || d.startsWith('1300') || d.startsWith('1800');
}

export function partACompanyIntro(phone) {
  if (String(phone || '').trim()) {
    return 'Pre-filled from signup. Confirm or update anything below.';
  }
  return 'Confirm or update anything below. Company phone can be left blank.';
}

export function auMobileIsValid(v) {
  let d = digits(v);
  if (d.startsWith('61')) d = `0${d.slice(2)}`;
  return d.length === 10 && d.startsWith('04');
}

/** Mirror of backend part_a_missing so the count is live while typing. */
export function partAMissing(values, { abnLocked = false } = {}) {
  const v = values || {};
  const missing = [];
  if (!String(v.company_name || '').trim()) missing.push('company_name');
  if (!v.abn_exempt) {
    const abn = String(v.abn || '').trim();
    // A locked (signup-verified) ABN is accepted as stored; a newly typed one must pass the checksum.
    if (!abn || (!abnLocked && !abnIsValid(abn))) missing.push('abn');
  }
  if (!String(v.address || '').trim()) missing.push('address');
  if (!String(v.suburb || '').trim()) missing.push('suburb');
  if (!AU_STATES.includes(String(v.state || '').toUpperCase())) missing.push('state');
  if (!/^\d{4}$/.test(String(v.postcode || '').trim())) missing.push('postcode');
  if (!companyPhoneIsAcceptable(v.phone)) missing.push('phone');
  if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v.company_email || '').trim())) missing.push('company_email');
  if (!String(v.timezone || '').startsWith('Australia/')) missing.push('timezone');
  if (!String(v.admin_first_name || '').trim()) missing.push('admin_first_name');
  if (!String(v.admin_last_name || '').trim()) missing.push('admin_last_name');
  if (!auMobileIsValid(v.admin_mobile)) missing.push('admin_mobile');
  return missing;
}

export function screenMissing(values, screen, options) {
  const fields = screen === 'you' ? YOU_SCREEN_FIELDS : COMPANY_SCREEN_FIELDS;
  return partAMissing(values, options).filter((f) => fields.includes(f));
}
